import * as React from "react";
import { Icon } from "sb-resp-ui";
import { EventCardIcon } from "../../EventCardIcon";
import { createEmptyTooltipIcon } from "./createEmptyTooltipIcon";
export const renderLiveStreamingIcon = (hasLiveStream, liveStreamingTooltip, showEmptyIcon, handler) => {
    const props = {
        className: "rj-ev-list__ev-card-icon--tooltip",
        tooltip: liveStreamingTooltip,
        onClick: handler
    };
    if (hasLiveStream) {
        return React.createElement(EventCardIcon, Object.assign({}, props),
            React.createElement(Icon, { i: "i-24-16 i-o-ev-streaming" }));
    }
    return showEmptyIcon ? createEmptyTooltipIcon() : React.createElement(React.Fragment, null);
};
//# sourceMappingURL=renderLiveStreamingIcon.js.map